import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

const BASE = `${API_BASE_URL}/equipment`;

// --- New Equipment ---
export const fetchNewEquipment = async (clusterId, academicYearId) => {
  let url = `${BASE}/new?`;
  if (clusterId) url += `cluster_id=${clusterId}&`;
  if (academicYearId) url += `academic_year_id=${academicYearId}`;
  const response = await fetch(url, { headers: getHeaders() });
  return handleResponse(response);
};

export const createNewEquipmentInvoice = async (data) => {
  const response = await fetch(`${BASE}/new`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateNewEquipmentInvoice = async (id, data) => {
  const response = await fetch(`${BASE}/new/invoice/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteNewEquipmentInvoice = async (id) => {
  const response = await fetch(`${BASE}/new/invoice/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

// --- Missing Items ---
export const fetchMissingItems = async (clusterId, academicYearId) => {
  let url = `${BASE}/missing?`;
  if (clusterId) url += `cluster_id=${clusterId}&`;
  if (academicYearId) url += `academic_year_id=${academicYearId}`;
  const response = await fetch(url, { headers: getHeaders() });
  return handleResponse(response);
};

export const createMissingItem = async (data) => {
  const response = await fetch(`${BASE}/missing`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const updateMissingItem = async (id, data) => {
  const response = await fetch(`${BASE}/missing/${id}`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const deleteMissingItem = async (id) => {
  const response = await fetch(`${BASE}/missing/${id}`, { method: 'DELETE', headers: getHeaders() });
  return handleResponse(response);
};

// --- Removed & Installed ---
export const fetchRemovedItems = async (clusterId, academicYearId) => {
  let url = `${BASE}/removed?`;
  if (clusterId) url += `cluster_id=${clusterId}&`;
  if (academicYearId) url += `academic_year_id=${academicYearId}`;
  const response = await fetch(url, { headers: getHeaders() });
  return handleResponse(response);
};

export const createRemovedItem = async (data) => {
  const response = await fetch(`${BASE}/removed`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const updateRemovedItem = async (id, data) => {
  const response = await fetch(`${BASE}/removed/${id}`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const deleteRemovedItem = async (id) => {
  const response = await fetch(`${BASE}/removed/${id}`, { method: 'DELETE', headers: getHeaders() });
  return handleResponse(response);
};

// --- Replacement Orders ---
export const fetchReplacementOrders = async (clusterId, academicYearId) => {
  let url = `${BASE}/replacement?`;
  if (clusterId) url += `cluster_id=${clusterId}&`;
  if (academicYearId) url += `academic_year_id=${academicYearId}`;
  const response = await fetch(url, { headers: getHeaders() });
  return handleResponse(response);
};

export const createReplacementOrder = async (data) => {
  const response = await fetch(`${BASE}/replacement`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const updateReplacementOrder = async (id, data) => {
  const response = await fetch(`${BASE}/replacement/${id}`, { method: 'PUT', headers: getHeaders(), body: JSON.stringify(data) });
  return handleResponse(response);
};

export const deleteReplacementOrder = async (id) => {
  const response = await fetch(`${BASE}/replacement/${id}`, { method: 'DELETE', headers: getHeaders() });
  return handleResponse(response);
};

export const renameReplacementType = async (oldType, newType) => {
  const response = await fetch(`${BASE}/replacement/type/rename`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ oldType, newType })
  });
  return handleResponse(response);
};

export const deleteReplacementType = async (typeName) => {
  const response = await fetch(`${BASE}/replacement/type/${encodeURIComponent(typeName)}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const bulkUpdateReplacementStatus = async (data) => {
  const response = await fetch(`${BASE}/replacement/bulk/status`, { 
    method: 'PUT', 
    headers: getHeaders(), 
    body: JSON.stringify(data) 
  });
  return handleResponse(response);
};
